import { ComponentPropsWithoutRef, ElementType } from "react";
import { cva } from "../../../../styled-system/css";

const squareButton = cva({
  base: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    padding: "0 24px",
    borderRadius: "4px",
  },
  variants: {
    variant: {
      contained: {
        bgColor: "primary.base",
        color: "primary.contrast",
        border: "none",
        _disabled: {
          bgColor: "black.300", // NOTE: デザインシステムとは異なる値
          color: "text.contrast", // NOTE: デザインシステムとは異なる値
          cursor: "not-allowed",
        },
      },
      outlined: {
        bgColor: "primary.contrast",
        color: "text.primary",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "border.base",
        _disabled: {
          bgColor: "inherit",
          color: "text.disabled",
          borderColor: "border.secondary",
          cursor: "not-allowed",
        },
      },
    },
    size: {
      full: {
        width: "100%",
        justifyContent: "center",
        height: "button.m",
        textStyle: "button.m",
      },
      m: {
        height: "button.m",
        textStyle: "button.m",
      },
      s: {
        height: "button.s",
        textStyle: "button.s",
      },
    },
  },
});

interface StyleProps {
  variant: "contained" | "outlined";
  size: "full" | "m" | "s";
}

type ButtonProps<T extends ElementType> = {
  tag?: T;
} & Omit<ComponentPropsWithoutRef<T>, "tag"> &
  StyleProps;

// MEMO: 今後bgColorやcolorも自由化になる（propsから渡す形になる）予定。仕様が未確定なので、いったんvariant単位で色を分けている。
export function SquareButton<T extends ElementType>({
  tag,
  variant,
  size,
  ...props
}: ButtonProps<T>) {
  const Tag = tag ?? "button";

  return (
    <Tag
      className={squareButton({
        variant,
        size,
      })}
      {...props}
    />
  );
}
